export const getOrderTypeLabel = (orderType: string): string => {
  switch (orderType.toLowerCase()) {
    case 'card':
      return 'Pedidos pagados';
    case 'cod':
      return 'COD';
    default:
      return orderType; // Fallback al valor original
  }
};